import { AfterViewInit, Component, ElementRef, HostListener, input, viewChild } from '@angular/core';

@Component({
	selector: 'back-top',
	standalone:true,
	styleUrls: ['./back-top.part.scss'],
	template: `<i #backTop class="fa-regular fa-angle-up back-to-top" title='Back to Top'></i>`
})
export class BackTopPart implements AfterViewInit {

	position = input(400);
	showSpeed = input(500);
	moveSpeed = input(1000);

	private readonly backTop = viewChild<ElementRef>('backTop');

	mainWrapper: HTMLElement | null = null;


	ngAfterViewInit() {
		this.mainWrapper = document.querySelector('.main-wrapper');
		if (this.mainWrapper) {
			this.mainWrapper.addEventListener('scroll', () => this.onScroll());
			this.onScroll();
		} else {
			console.error("Main wrapper element not found!");
		}
	}

	@HostListener('click') _onClick(): boolean {
		const mainWrapper = document.querySelector('.main-wrapper') as HTMLElement;
		if (mainWrapper) {
			mainWrapper.scrollTo({ top: 0, behavior: 'smooth' });
		} else {
			console.error("Main wrapper element not found!");
		}
		return false;
	}

	onScroll(): void {
		if (this.mainWrapper && this.backTop()) {
			const w = this.mainWrapper;
			const el = this.backTop()!.nativeElement;

			if (w.scrollTop > this.position()) {
				el.style.transition = `opacity ${this.showSpeed() / 1000}s ease-in-out`;
				el.style.opacity = '1';
			} else {
				el.style.transition = `opacity ${this.showSpeed() / 1000}s ease-in-out`;
				el.style.opacity = '0';
			}
		}
	}
}